import { Layout, Row, Col } from "antd";
import { Content } from "antd/lib/layout/layout";
import { usePageTitle } from "hooks";

const InsightsPage: React.FC = () => {
  usePageTitle("Insights");
  return (
      <Layout className="mainInnerLayout">
        <Content className="mainContainer">
          <div className="innerHeader">
            <Row>
              <Col span={24}>
                <h3>Coming Soon</h3>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
  );
};

export default InsightsPage;
